import { Scenarios } from '@jfs/network'

const addAgentUserIdentity = {
  default: [
    {
      url: /agent-user\/identity/,
      method: 'POST',
      response: {
        status: 'SUCCESS',
      },
      delay: 500,
    },
  ],
  failed: [
    {
      url: /agent-user\/identity/,
      method: 'POST',
      responseCode: 5000,
      response: { error: { code: 416, message: 'Invalid request' } },
      delay: 1000,
    },
  ],
} as Scenarios

export { addAgentUserIdentity }
